export type ClinicalQualityRecommendation = 'no_action' | 'written_feedback_coaching' | 'escalate'

const RECOMMENDATION_COLORS: Record<ClinicalQualityRecommendation, string> = {
  no_action: 'text-forest-light',
  written_feedback_coaching: 'text-blue-600',
  escalate: 'text-orange',
}

export interface ClinicalQualityScoreChipProps {
  percentage?: number | null
  recommendation?: string | null
}

export function ClinicalQualityScoreChip({
  percentage,
  recommendation,
}: ClinicalQualityScoreChipProps) {
  if (percentage == null) {
    return <span className="text-charcoal-50 text-xs">Not scored</span>
  }

  const colorClass =
    (recommendation && RECOMMENDATION_COLORS[recommendation as ClinicalQualityRecommendation]) ??
    'text-charcoal'

  return <span className={`font-semibold ${colorClass}`}>{percentage.toFixed(0)}%</span>
}
